module.exports = __webpack_public_path__ + "static/media/Deron-logo-client-page-01.260a8c24.png";